export default __webpack_public_path__ + "static/media/i-circle-icn.0c431420.svg";